import React from "react";
import { Box, TextField, IconButton } from "@mui/material";
import PropTypes from "prop-types";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const MonthlyPicker = ({ value, onChange }) => {
  const handleMonthChange = (offset) => {
    const parts = value.split("-");
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;

    if (isNaN(year) || isNaN(month)) return;

    const date = new Date(year, month + offset, 1);
    const newValue = date.toISOString().slice(0, 7);
    onChange(newValue);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {/* <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
        {label}
      </Typography> */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <IconButton
          size="small"
          onClick={() => handleMonthChange(-1)}
          sx={{ border: "1px solid #ccc", borderRadius: 1 }}
        >
          <ChevronLeftIcon />
        </IconButton>
        <TextField
          type="month"
          size="small"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          sx={{ width: 200 }}
          InputLabelProps={{ shrink: true }}
        />
        <IconButton
          size="small"
          onClick={() => handleMonthChange(1)}
          sx={{ border: "1px solid #ccc", borderRadius: 1 }}
        >
          <ChevronRightIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

MonthlyPicker.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default MonthlyPicker;
